import { Button, Paper, styled, } from "@mui/material";
import { Form } from "formik";
import FormikPasswordTextfield from "../commons/formik/FormikPasswordTextfield";
import FormikTextField from "../commons/formik/FormikTextField";

export const StyledLogin = {
  Container: styled('div')(({ theme }) => ({
    display: "flex",
    justifyContent: "center",
    height: "100vh",
    width: "100vw",
    alignItems: "center",
    background: `linear-gradient(to right, ${theme.palette.primary.main}, ${theme.palette.tertiary.main})`,
  })),
  Content: styled(Paper)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    height: "fit-content",
    margin: "auto",
    padding: "20px",
    borderRadius: "10px",
  })),
  Logo: styled('img')(({ theme }) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: 100,
  })),
  Form: styled(Form)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: "1vh",
    width: "100%",
  })),
  TextField: styled(FormikTextField)(({ theme }) => ({
    width: "100%",
    // que "Usuario" y "Contraseña" aparezcan en negrita
    "& label": {
      fontSize: 17.3,
      fontWeight: 600,
    },
  })),
  Password: styled(FormikPasswordTextfield)(({ theme }) => ({
    width: "100%",
    // que "Usuario" y "Contraseña" aparezcan en negrita
    "& label": {
      fontSize: 17.3,
      fontWeight: 600,
    },
  })),
  Button: styled(Button)(({ theme }) => ({
    backgroundColor: `${theme.palette.tertiary.main}`,
  })),
  ForgotPasswordContainer: styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    '& a': {
      textDecoration: 'none',
      color: theme.palette.primary.main,
      fontWeight: 500,
    }
  })),
}